import { tv } from 'tailwind-variants'

export const FAVORITE_ICON_VARIANTS = tv({
  base: '',
  variants: {
    variant: {
      base: 'tw-fill-primary-500',
      light: 'tw-fill-accentBlue-500',
    },
  },
})

export const FAVORITE_ICON_STROKE_VARIANTS = tv({
  base: '',
  variants: {
    variant: {
      base: 'tw-stroke-primary-500',
      light: 'tw-stroke-accentBlue-500',
    },
  },
})
